import { Check, Zap, Shield, TrendingDown } from "lucide-react";

export default function BenefitsSection() {
  const benefits = [
    "Se sua estrutura realmente suporta o ritmo atual de crescimento",
    "Se o esforço da sua equipe está aumentando sem aumento proporcional de resultado",
    "Se sua meta exige mais do que sua operação consegue sustentar",
    "Se existe um problema em formação que ainda não apareceu no caixa",
    "Se a pressão operacional está se acumulando silenciosamente",
  ];

  const outcomes = [
    { icon: TrendingDown, title: "Antecipação reduz risco" },
    { icon: Zap, title: "Previsibilidade reduz estresse" },
    { icon: Shield, title: "Clareza reduz erro" },
  ];

  return (
    <section
      id="benefits"
      className="relative py-16 md:py-32 bg-[#0A0B0E]"
      data-testid="benefits-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1 text-xs font-mono tracking-widest uppercase text-[#F59E0B] bg-[#0E3A46] border border-[#F59E0B]/20 rounded-sm mb-6">
            Benefícios
          </span>

          <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-[#E5E7EB]">
            O que você passa a <span className="text-[#F59E0B]">enxergar</span>
          </h2>
        </div>

        {/* Benefits Grid */}
        <div className="max-w-3xl mx-auto mb-16">
          <p className="text-center text-[#9CA3AF] text-base md:text-lg mb-10">
            Na prática, isso significa que você passa a:
          </p>

          <div className="bg-[#1C1F26] border border-[#2A2F38] rounded-sm p-8 md:p-10">
            <div className="space-y-4">
              {benefits.map((benefit, index) =>
                (
                  <div
                    key={index}
                    className="flex items-start gap-4 py-3 border-b border-[#2A2F38] last:border-0"
                    data-testid={`benefit-${index}`}
                  >
                    <div className="flex-shrink-0 w-6 h-6 flex items-center justify-center bg-[#F59E0B]/10 rounded-sm">
                      <Check className="h-4 w-4 text-[#F59E0B]" />
                    </div>
                    <span className="text-[#E5E7EB] text-base md:text-lg">
                      {benefit}
                    </span>
                  </div>
                )
              )}
            </div>

            {/* Insight Quote */}
            <div className="border-t border-[#2A2F38] pt-6 mt-4">
              <p className="text-[#E5E7EB] text-sm md:text-base font-medium mb-1">
                Nem toda meta falha por falta de esforço.
              </p>
              <p className="text-[#9CA3AF] text-sm md:text-base">
                Muitas falham porque a estrutura e a dinâmica da operação não conseguem sustentar o ritmo necessário.
              </p>
            </div>
          </div>
        </div>

        {/* Outcomes */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
          {outcomes.map((outcome, index) => (
            <div
              key={index}
              className="text-center p-6 bg-[#1C1F26] border border-[#2A2F38] rounded-sm hover:border-[#F59E0B]/50 transition-all"
            >
              <outcome.icon className="h-8 w-8 text-[#F59E0B] mx-auto mb-4" />
              <p className="text-[#E5E7EB] font-medium">{outcome.title}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
